module.exports = __webpack_public_path__ + "static/media/icon-menu.52ff8e5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/Images/icon-menu.svg
// module id = 491
// module chunks = 0